import BaseStore from '@/store/base-store'

const options = {
  actions: {
    clear ({ commit }) {
      commit('item', {})
    }
  }
}
export default new BaseStore('notes', options)



// WEBPACK FOOTER //
// ./src/store/modules/notes.store.js